import {reactFetchJSON} from '@github-ui/verified-fetch'
import type {IssueType} from './issue-type'
import type {GraphQLResponse} from '@github-ui/item-picker-base/api/graphql'
import {buildItemPickerSearchUrl} from '@github-ui/item-picker-base/api/urls'
import {SearchIssueTypes} from '@github-ui/server-persisted-queries'
import type {SearchIssueTypesQuery} from '@github-ui/server-persisted-queries/types/SearchIssueTypes'

export type GetSearchIssueTypesRequest = {
  owner: string
  repo: string
  query?: string
  count?: number
}

export type GetSearchIssueTypesResponse = GraphQLResponse<SearchIssueTypesQuery>

export async function apiGetSearchIssueTypes({
  owner,
  repo,
  query,
  count,
}: GetSearchIssueTypesRequest): Promise<GetSearchIssueTypesResponse> {
  const params: Record<string, unknown> = {owner, repo, queryId: SearchIssueTypes}

  if (query) {
    params['query'] = query
  }

  if (count) {
    params['count'] = count
  }

  const requestUrl = buildItemPickerSearchUrl('issue_types', params)
  const request = await reactFetchJSON(requestUrl)
  return (await request.json()) as GetSearchIssueTypesResponse
}

const itemPickerQueryKeyBase = 'item_picker'

export function buildItemPickerIssueTypeSearchQueryKey(searchParams: GetSearchIssueTypesRequest) {
  return [itemPickerQueryKeyBase, 'issue_types', searchParams]
}

export type IssueTypePickerQueryData = {
  issueTypes: IssueType[]
}

export function transformSearchIssueTypeResponseToQueryData(response: SearchIssueTypesQuery): IssueTypePickerQueryData {
  const edges = response.repository?.issueTypes?.edges ?? []
  return {
    issueTypes: edges.flatMap(edge => (edge?.node ? edge?.node : [])),
  }
}
